import { ngModuleRegistrar } from "../../helpers";
import {
  EventsBrokerPmsApiService,
  ConfigPmsApiServiceProvider as ConfigPmsApiService,
  AuthAccessPmsApiService,
  AuthPasswordPmsApiService,
  AuthUserPmsApiService,
  AuthSetPasswordPmsApiService,
  CountryPmsApiService,
  CityPmsApiService,
  GuestsStatusPmsApiService,
  PropertyTypePmsApiService,
  PropertyClassPmsApiService,
  PropertyPmsApiService,
  UserPmsApiService,
  ImageUploadPmsApiService,
  AmenityCategoryPmsApiService,
  DefaultPropertyAmenityPmsApiService,
  DefaultRoomAmenityPmsApiService,
  TaxFeePmsApiService,
  GeneralSettingsPmsApiService,
  RatingFactorsPmsApiService,
  ItemCategoryPmsApiService,
  PropertyAmenityPmsApiService,
  ItemPmsApiService,
  PropertyAccommodationTypePmsApiService,
  PolicyPmsApiService,
  NotificationRecipientPmsApiService,
  PropertyUserPmsApiService,
  RolePmsApiService,
  AddonPmsApiService,
  AddonIntervalPmsApiService,
  InvoicingPmsApiService,
  EmailTemplatePmsApiService,
  CustomFieldPmsApiService,
  ReservationSourcePmsApiService,
  RegistrationCardPmsApiService,
  CurrencyPmsApiService,
  CreditCardPaymentOptionPmsApiService,
  AdditionalPaymentOptionPmsApiService,
  BankTransferPaymentOptionPmsApiService,
  CreditCardTypePmsApiService,
  SchedulePmsApiService,
  BaseRatePmsApiService,
  TemplatePmsApiService,
  SmsTemplatePmsApiService,
  GuestPmsApiService,
  GuestReservationHistoryPmsApiService,
  RatePlanPmsApiService,
  RatePlanIntervalPmsApiService,
  GuestNotePmsApiService,
  GuestDocumentPmsApiService,
  ReservationPmsApiService,
  ReservationNotePmsApiService,
  ReservationAccommodationPmsApiService,
  PaymentOptionPmsApiService,
  ReservationTransactionPmsApiService,
  CreditCardPmsApiService,
  ReservationDocumentPmsApiService,
  ReservationInvoicePmsApiService,
  ReservationActivityPmsApiService,
  ReservationCommunicationPmsApiService,
  DashboardPmsApiService,
  EventAdditionalOptionPmsApiService,
  EventCalendarPmsApiService,
  SupplierPmsApiService,
  FurniturePmsApiService,
  AssetPmsApiService,
  HouseAccountPmsApiService,
  HouseAccountTransactionService,
  FeedbackPmsApiService,
  HousekeeperPmsApiService,
  MabeetRolePmsApiService,
  MabeetUserPmsApiService,
  StaffActivityPmsApiService,
  ActivityLogPmsApiService,
  CouponPmsApiService,
  AddonSettingPmsApiService,
  SmsAccountSettingsPmsApiService,
  GuestsListPmsApiService,
  GuestsListPhoneNumberPmsApiService,
  SmsPmsApiService,
  SmsTransactionPmsApiService,
  CreditCardSecurityPmsApiService,
  ScheduledMaintenancePmsApiService,
  CreditCardPasswordPmsApiService,
  DemoRequestPmsApiService,
  BillingInformationPmsApiService,
  BillingTransactionPmsApiService,
  SupportRequestPmsApiService,
  BillingInvoicePmsApiService,
  BillingBankPmsApiService,
  SubscriptionPmsApiService,
  AccountCancellationPmsApiService,
  SubscriptionSettingPmsApiService,
  InternalMessagePmsApiService,
  EmailReminderPmsApiService,
  SmsReminderPmsApiService,
  PaymentDetailPmsApiService,
  ReservationsByRatePlanReportPmsApiService,
  ChannelProductionReportPmsApiService,
  AverageDailyRatePmsApiService,
  FrontDeskCancellationReportPmsApiService,
  FrontDeskNoShowReportPmsApiService,
  FrontDeskInHouseReportPmsApiService,
  FrontDeskDepartureReportPmsApiService,
  FrontDeskArrivalReportPmsApiService,
  SubscriptionEmailNotificationPmsApiService,
  SmsLogPmsApiService,
  ReservationsByCountryReportPmsApiService,
  BaseSubscriptionPmsApiService,
  SmsRatePmsApiService,
  IssetAddonInSubscriptionService,
  CashDrawerPmsApiService,
  CashDrawerTransactionPmsApiService,
  RevenuePerAvailableRoomPmsApiService,
  OccupancyPmsApiService,
  SubscriptionCancellationPmsApiService,
  AccountBalancesPmsApiService,
  CashierReportPmsApiService,
  InvoicesDetailPmsApiService,
  SalesAddonPmsApiService,
  SalesPropertyPmsApiService,
  RoomAssignmentsPmsApiService,
  PaymentDetailsPmsApiService,
  PaymentFailurePmsApiService,
  RefundDetailsPmsApiService,
  FinancialTransactionsReportPmsApiService,
  AdjustmentsReportPmsApiService,
  NotesReportPmsApiService,
  SubscriptionsSummaryPmsApiService,
  PaymentReconciliationPmsApiService,
  UserReconciliationPmsApiService,
  TaxesReportPmsApiService,
  SummaryStatementPmsApiService,
  RoomMoveReportPmsApiService,
  DailyRevenuePmsApiService,
  PayoutCommissionReportPmsApiService,
  DailyFinancialPmsApiService,
  PaymentLedgerReportPmsApiService,
  SecurityDepositPmsApiService,
  DailyTransactionsPmsApiService,
  InvoiceContentPmsApiService,
  SCTHApiSettingPmsApiService,
  NTMPFinancialSettingPmsApiService,
  NTMPFinanceFacilitySettingPmsApiService,
  NTMPAccountCatalogPmsApiService,
  SCTHApiLogPmsApiService,
  ShomoosApiSettingPmsApiService,
  ShomoosApiLogPmsApiService,
  ShomoosRoomsMappingPmsApiService,
  MabeetProfileService,
  PaymentGatewayApiSettingService,
  PaymentGatewayApiLogService,
  MabeetPaymentGatewayApiSettingsService,
  BankService,
  PaytabsService,
  StaahRoomTypeService,
  ChannelManagerTariffSettingsService,
  PropertyProfilePmsApiService,
  ChannelManagerGlobalSettingsService,
  PropertyChannelDistributionPmsApiService,
  ChannelMappingPmsApiService,
  OnlineReservationPmsApiService,
  PropertyChannelsService,
  CloseoutService,
  CurrencyCodeService,
  ChannelUpdateLogPmsApiService,
  ChannelRatesInventoryLogPmsApiService,
  BaladyApiSettingPmsApiService,
  BaladyApiLogPmsApiService,
  ZatcaApiSettingPmsApiService,
  ZatcaApiLogPmsApiService,
  MunicipalityFeesReportPmsApiService,
  SubscriptionCreditNotePmsApiService,
  ThirdPartyReservationSourcePmsApiService,
  NumberingSettingsPmsApiService,
  ReceiptVoucherPmsApiService,
  PaymentVoucherPmsApiService,
  ExpensesPaymentPmsApiService,
  ExpensesItemPmsApiService,
  DropCashVoucherPmsApiService,
  InvoicesReportPmsApiService,
  DetailedTaxesFeesReportPmsApiService,
  SingleTransactionPmsApiService,
  PropertyRoomsPmsApiService,
} from "./index";
import { AccountPmsApiService } from "./account.service";
import { AbstractPmsApiService } from "./abstract.service";
import { RecurringPlanPmsApiService } from "./recurring-plan.service";

const providers = ngModuleRegistrar("provider", {
  ConfigPmsApiService,
});
const services = ngModuleRegistrar("service", {
  EventsBrokerPmsApiService,
  AuthAccessPmsApiService,
  AuthPasswordPmsApiService,
  AuthUserPmsApiService,
  CountryPmsApiService,
  CityPmsApiService,
  GuestsStatusPmsApiService,
  PropertyTypePmsApiService,
  PropertyClassPmsApiService,
  PropertyPmsApiService,
  UserPmsApiService,
  ImageUploadPmsApiService,
  AmenityCategoryPmsApiService,
  DefaultPropertyAmenityPmsApiService,
  DefaultRoomAmenityPmsApiService,
  TaxFeePmsApiService,
  GeneralSettingsPmsApiService,
  ItemCategoryPmsApiService,
  PropertyAmenityPmsApiService,
  ItemPmsApiService,
  PropertyAccommodationTypePmsApiService,
  PolicyPmsApiService,
  NotificationRecipientPmsApiService,
  AccountPmsApiService,
  PropertyUserPmsApiService,
  RolePmsApiService,
  AddonPmsApiService,
  AddonIntervalPmsApiService,
  InvoicingPmsApiService,
  EmailTemplatePmsApiService,
  CustomFieldPmsApiService,
  ReservationSourcePmsApiService,
  RegistrationCardPmsApiService,
  CurrencyPmsApiService,
  CreditCardPaymentOptionPmsApiService,
  AdditionalPaymentOptionPmsApiService,
  SchedulePmsApiService,
  BankTransferPaymentOptionPmsApiService,
  CreditCardTypePmsApiService,
  BaseRatePmsApiService,
  TemplatePmsApiService,
  SmsTemplatePmsApiService,
  GuestPmsApiService,
  GuestReservationHistoryPmsApiService,
  RatePlanPmsApiService,
  RatePlanIntervalPmsApiService,
  GuestNotePmsApiService,
  GuestDocumentPmsApiService,
  ReservationPmsApiService,
  ReservationNotePmsApiService,
  ReservationAccommodationPmsApiService,
  PaymentOptionPmsApiService,
  ReservationTransactionPmsApiService,
  ReservationDocumentPmsApiService,
  ReservationInvoicePmsApiService,
  CreditCardPmsApiService,
  AbstractPmsApiService,
  ReservationActivityPmsApiService,
  ReservationCommunicationPmsApiService,
  DashboardPmsApiService,
  EventAdditionalOptionPmsApiService,
  EventCalendarPmsApiService,
  SupplierPmsApiService,
  FurniturePmsApiService,
  AssetPmsApiService,
  HouseAccountPmsApiService,
  HouseAccountTransactionService,
  FeedbackPmsApiService,
  HousekeeperPmsApiService,
  MabeetRolePmsApiService,
  MabeetUserPmsApiService,
  StaffActivityPmsApiService,
  ActivityLogPmsApiService,
  CouponPmsApiService,
  AddonSettingPmsApiService,
  SmsAccountSettingsPmsApiService,
  GuestsListPmsApiService,
  GuestsListPhoneNumberPmsApiService,
  SmsPmsApiService,
  SmsTransactionPmsApiService,
  CreditCardSecurityPmsApiService,
  ScheduledMaintenancePmsApiService,
  CreditCardPasswordPmsApiService,
  DemoRequestPmsApiService,
  BillingInformationPmsApiService,
  BillingTransactionPmsApiService,
  SupportRequestPmsApiService,
  BillingInvoicePmsApiService,
  BillingBankPmsApiService,
  SubscriptionPmsApiService,
  AccountCancellationPmsApiService,
  SubscriptionSettingPmsApiService,
  InternalMessagePmsApiService,
  EmailReminderPmsApiService,
  SmsReminderPmsApiService,
  PaymentDetailPmsApiService,
  ReservationsByRatePlanReportPmsApiService,
  ChannelProductionReportPmsApiService,
  AverageDailyRatePmsApiService,
  FrontDeskCancellationReportPmsApiService,
  FrontDeskNoShowReportPmsApiService,
  FrontDeskInHouseReportPmsApiService,
  FrontDeskDepartureReportPmsApiService,
  FrontDeskArrivalReportPmsApiService,
  SubscriptionEmailNotificationPmsApiService,
  SmsLogPmsApiService,
  ReservationsByCountryReportPmsApiService,
  BaseSubscriptionPmsApiService,
  SmsRatePmsApiService,
  IssetAddonInSubscriptionService,
  CashDrawerPmsApiService,
  CashDrawerTransactionPmsApiService,
  RevenuePerAvailableRoomPmsApiService,
  OccupancyPmsApiService,
  SubscriptionCancellationPmsApiService,
  AccountBalancesPmsApiService,
  CashierReportPmsApiService,
  InvoicesDetailPmsApiService,
  SalesAddonPmsApiService,
  SalesPropertyPmsApiService,
  RoomAssignmentsPmsApiService,
  PaymentDetailsPmsApiService,
  PaymentFailurePmsApiService,
  RefundDetailsPmsApiService,
  FinancialTransactionsReportPmsApiService,
  AdjustmentsReportPmsApiService,
  NotesReportPmsApiService,
  SubscriptionsSummaryPmsApiService,
  PaymentReconciliationPmsApiService,
  UserReconciliationPmsApiService,
  TaxesReportPmsApiService,
  SummaryStatementPmsApiService,
  RoomMoveReportPmsApiService,
  DailyRevenuePmsApiService,
  PayoutCommissionReportPmsApiService,
  DailyFinancialPmsApiService,
  PaymentLedgerReportPmsApiService,
  SecurityDepositPmsApiService,
  DailyTransactionsPmsApiService,
  InvoiceContentPmsApiService,
  SCTHApiSettingPmsApiService,
  NTMPFinancialSettingPmsApiService,
  NTMPFinanceFacilitySettingPmsApiService,
  NTMPAccountCatalogPmsApiService,
  SCTHApiLogPmsApiService,
  RecurringPlanPmsApiService,
  ShomoosApiSettingPmsApiService,
  ShomoosApiLogPmsApiService,
  ShomoosRoomsMappingPmsApiService,
  MabeetProfileService,
  PaymentGatewayApiLogService,
  PaymentGatewayApiSettingService,
  MabeetPaymentGatewayApiSettingsService,
  BankService,
  PaytabsService,
  StaahRoomTypeService,
  ChannelManagerTariffSettingsService,
  PropertyProfilePmsApiService,
  ChannelManagerGlobalSettingsService,
  PropertyChannelDistributionPmsApiService,
  ChannelMappingPmsApiService,
  OnlineReservationPmsApiService,
  PropertyChannelsService,
  CloseoutService,
  CurrencyCodeService,
  ChannelUpdateLogPmsApiService,
  ChannelRatesInventoryLogPmsApiService,
  BaladyApiSettingPmsApiService,
  BaladyApiLogPmsApiService,
  ZatcaApiSettingPmsApiService,
  ZatcaApiLogPmsApiService,
  MunicipalityFeesReportPmsApiService,
  SubscriptionCreditNotePmsApiService,
  ThirdPartyReservationSourcePmsApiService,
  NumberingSettingsPmsApiService,
  ReceiptVoucherPmsApiService,
  PaymentVoucherPmsApiService,
  ExpensesPaymentPmsApiService,
  ExpensesItemPmsApiService,
  DropCashVoucherPmsApiService,
  InvoicesReportPmsApiService,
  DetailedTaxesFeesReportPmsApiService,
  RatingFactorsPmsApiService,
  SingleTransactionPmsApiService,
  PropertyRoomsPmsApiService,
}); 
 
export default (module) => {
  providers(module);
  services(module); 
};



// WEBPACK FOOTER //
// ./src/pms-api/services/register.js